// extracted by mini-css-extract-plugin
module.exports = {"articles":"Card_articles__2w7JL","article":"Card_article__1aglu","imageContainer":"Card_imageContainer__1YBVg","text":"Card_text__3BS0F","source":"Card_source__1ErHD"};